import React, { useMemo } from 'react';

import { LANGUAGE_KEYS } from 'config/languageKeys';

import { androidScreenMarginBottom } from 'utils/responsiveness';

import {
    DIALOG_ERR_GENERIC_BODY,
    DIALOG_ERR_GENERIC_TITLE,
} from 'screens/Collection/constants';

import DialogView from 'components/Dialog';
import { DialogProps } from 'components/Dialog/types';

type Props = DialogProps & {
    errorStatus?: number | null;
};

const {
    ERROR_SERVICE_NOT_AVAILABLE_TITLE,
    ERROR_SERVICE_NOT_AVAILABLE_BODY,
    TRY_AGAIN_BUTTON,
} = LANGUAGE_KEYS;

const ErrorDialog = ({
    visible,
    errorStatus,
    title,
    description,
    actionButtonTitle,
    cancelButtonTitle,
    actionButtonOnPress,
    actionButtonFillColor,
    actionButtonTextStyle,
    ...rest
}: Props) => {
    const errorContent = useMemo(() => {
        if (errorStatus === 503) {
            return {
                title: ERROR_SERVICE_NOT_AVAILABLE_TITLE,
                description: ERROR_SERVICE_NOT_AVAILABLE_BODY,
                actionButtonText: TRY_AGAIN_BUTTON,
                cancelButtonText: undefined,
            };
        }

        if (title || description || actionButtonTitle || cancelButtonTitle) {
            return {
                title: title || DIALOG_ERR_GENERIC_TITLE,
                description: description || DIALOG_ERR_GENERIC_BODY,
                actionButtonText: actionButtonTitle,
                cancelButtonText: cancelButtonTitle,
            };
        }

        return {
            title: DIALOG_ERR_GENERIC_TITLE,
            description: DIALOG_ERR_GENERIC_BODY,
            actionButtonText: TRY_AGAIN_BUTTON,
            cancelButtonText: undefined,
        };
    }, [errorStatus, title, description, actionButtonTitle, cancelButtonTitle]);

    return (
        <DialogView
            visible={visible}
            title={errorContent.title}
            description={errorContent.description}
            actionButtonTitle={errorContent.actionButtonText}
            actionButtonOnPress={actionButtonOnPress}
            actionButtonFillColor={actionButtonFillColor}
            actionButtonTextStyle={actionButtonTextStyle}
            {...rest}
            cancelButtonTitle={errorContent.cancelButtonText}
            style={{ marginBottom: androidScreenMarginBottom }}
        />
    );
};

export default ErrorDialog;
